import React, { useState } from 'react';
import { Box, Button, Stack, IconButton, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

const WeekPicker = ({ onWeekChange, selectedWeek: externalSelectedWeek }) => {
  const theme = useTheme();

  const getWeekStart = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Monday as start of week
    return new Date(d.setDate(diff));
  };

  const getCurrentWeek = () => {
    return getWeekStart(new Date());
  };

  const [selectedWeek, setSelectedWeek] = useState(externalSelectedWeek || getCurrentWeek());

  const handleWeekChange = (newWeek) => {
    setSelectedWeek(newWeek);
    if (onWeekChange) {
      onWeekChange(newWeek);
    }
  };

  const navigateWeek = (direction) => {
    // Disabled for now - arrows do nothing
    console.log(`Week navigation clicked: ${direction > 0 ? 'forward' : 'back'}`);
  };

  const goToCurrentWeek = () => {
    handleWeekChange(getCurrentWeek());
  };

  const canGoBack = (() => {
    const prevWeek = new Date(selectedWeek);
    prevWeek.setDate(prevWeek.getDate() - 7);
    const currentWeek = getCurrentWeek();
    const weeksDiff = Math.floor((prevWeek - currentWeek) / (1000 * 60 * 60 * 24 * 7));
    return weeksDiff >= -1;
  })();

  const canGoForward = (() => {
    const nextWeek = new Date(selectedWeek);
    nextWeek.setDate(nextWeek.getDate() + 7);
    const currentWeek = getCurrentWeek();
    const weeksDiff = Math.floor((nextWeek - currentWeek) / (1000 * 60 * 60 * 24 * 7));
    return weeksDiff <= 1;
  })();

  const currentWeek = getCurrentWeek();
  const weeksDiff = Math.floor((selectedWeek - currentWeek) / (1000 * 60 * 60 * 24 * 7));
  const isCurrentWeek = weeksDiff === 0;

  const getWeekLabel = () => {
    if (weeksDiff === 0) return "THIS WEEK";
    if (weeksDiff === -1) return "LAST WEEK";
    if (weeksDiff === 1) return "NEXT WEEK";
    
    // For other weeks, show "Week of [date]"
    const weekStart = new Date(selectedWeek);
    return `WEEK OF ${weekStart.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric' 
    }).toUpperCase()}`;
  };

  return (
    <Box sx={{ mb: 4, textAlign: 'center' }}>
      <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" sx={{ mb: 3 }}>
        <IconButton 
          onClick={() => navigateWeek(-1)}
          sx={{ 
            color: theme.palette.text.primary
          }}
        >
          <Typography variant="h5">‹</Typography>
        </IconButton>
        
        <Button
          variant="contained"
          onClick={() => console.log('This week clicked')}
          sx={{
            borderRadius: "20px",
            px: 3,
            py: 1,
            fontWeight: 600,
            textTransform: "none",
            minWidth: 160
          }}
        >
          THIS WEEK
        </Button>
        
        <IconButton 
          onClick={() => navigateWeek(1)}
          sx={{ 
            color: theme.palette.text.primary
          }}
        >
          <Typography variant="h5">›</Typography>
        </IconButton>
      </Stack>
    </Box>
  );
};

export default WeekPicker;